import { GET_MATERIAL_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_MATERIAL_RECIPES_SUCCESS: {
      const materialRecipes = action.payload;

      if (!materialRecipes){
        return {...state};
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
